import React, { memo } from "react";
import { IconStyled } from "./style";

const Icon = ({ src, alt, ...props }) => {
  return <IconStyled src={src} alt={alt} loading="lazy" {...props} />;
};

export default memo(Icon);
